import React, { useEffect } from 'react';
import { Flex } from 'antd';

import { useFilters } from '../../../../shops/features/products/hooks/useFilters';
import {
    ChatFilters,
    ChatProps,
    COMMUNITY_TYPE,
} from '../interface/chats.interface';
import { getInitialFilters } from '../utils/filters';
import { FETCH_DELAY } from '../../../../crm/utils/common';
import { ChatsTable } from '../components/ChatsTable';
import { TableActions } from '../components/TableActions';
import { useLazyReadChatsQuery } from '../service/chat.api';

export const MonitoringContainer = () => {
    const {
        filters,
        get: fetchChats,
        source,
        loading,
        updateFilters,
        getColumnSearchProps,
    } = useFilters<ChatFilters, ChatProps>(
        useLazyReadChatsQuery,
        getInitialFilters(COMMUNITY_TYPE.MONITORING)
    );

    useEffect(() => {
        const timeout = setTimeout(() => {
            const payload = {
                ...filters,
            };

            fetchChats(payload, true);
        }, FETCH_DELAY);
        return () => clearTimeout(timeout);
    }, [filters, fetchChats]);

    const commonProps = {
        loading: loading,
        filters: filters,
        updateFilters: updateFilters,
    };

    return (
        <Flex vertical gap={24}>
            <TableActions
                communityType={COMMUNITY_TYPE.MONITORING}
                {...commonProps}
            />
            <ChatsTable
                source={source || []}
                getColumnSearchProps={getColumnSearchProps}
                {...commonProps}
            />
        </Flex>
    );
};
